import axios from "axios";
import secureAxios from "../secure_axios";

const login = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/login/token/`
})

const baseUrlSecureAxios = 'login/token/'

async function ServGetTokenNTM(tokenSMS) {
    const response = await login.get('', { headers: { Authorization: `Bearer ${tokenSMS}` } });
    return response
}

async function ServGetTokenHttpOnly(tokenSMS) {
    const response = await login.get('http-only', { headers: { Authorization: `Bearer ${tokenSMS}` } });
    return response
}

async function servValidacaoToken() {
    const response = await secureAxios.get(baseUrlSecureAxios + 'validacao');
    return response
}

async function servInvalidarToken() {
    const response = await login.get('invalidar');
    return response
}

export {
    ServGetTokenNTM,
    ServGetTokenHttpOnly,
    servValidacaoToken,
    servInvalidarToken
}